import "./profile.css";

import React, { Component } from "react";

import Api from "../services/api";
import AuthService from "../services/auth";
import ProfileBasic from "../components/ProfileBasic";
import ProfileDescription from "../components/ProfileDescription";
import ProfileLocations from "../components/ProfileLocations";
import ProfileMenu from "../components/ProfileMenu";
import ProfilePersonal from "../components/ProfilePersonal";
import ProfilePhotos from "../components/ProfilePhotos";
import ProfileSubscriptions from "../components/ProfileSubscriptions";

class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: this.props.match.params.type,
      user: {}
    };
  }

  componentDidMount() {
    if (!AuthService.isLoggedIn()) {
      window.location = "/join";
    } else {
      new Api()
        .get("/users/current", {}, AuthService.getAuthCookie())
        .then(response => {
          this.setState({
            user: response.user
          });
        });
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      active: newProps.match.params.type
    });
  }

  render() {
    const { user } = this.state;
    return (
      <div className="container profile">
        {AuthService.isLoggedIn() && (
          <div className="row">
            <ProfileMenu active={this.state.active} current={user} />
            {this.state.active === "basic" && (
              <ProfileBasic title="Basic Information" />
            )}
            {this.state.active === "description" && (
              <ProfileDescription title="Descriptions" />
            )}
            {this.state.active === "personal" && (
              <ProfilePersonal
                titles={["What do you look like", "More about you"]}
              />
            )}
            {this.state.active === "photos" && <ProfilePhotos title="Photos" />}
            {this.state.active === "location" && (
              <ProfileLocations title="Locations" />
            )}
            {this.state.active === "subscription" && (
              <ProfileSubscriptions title="Subscriptions" />
            )}
          </div>
        )}
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/pages/profile.js